import React from 'react';
import { Button } from '@/components/ui';
import { ImageWithFallback } from '@/components/ui';
import { STORE_DETAILS, ASSETS, ASSET_DIMENSIONS, FALLBACK_IMAGES } from '@/config/store';

export function CredentialsSection() {
  const phoneHref = `tel:${STORE_DETAILS.phone.replace(/\s/g, '')}`;

  return (
    <section
      aria-labelledby="heritage-heading"
      className="scroll-mt-24 bg-white border-t border-ink/8"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-12 sm:py-16 lg:py-20">
        <div className="max-w-2xl mb-8 sm:mb-12">
          <p className="text-sm font-medium text-brand mb-3 inline-flex items-center gap-2">
            <span className="h-px w-5 bg-brand/50" aria-hidden />
            Since {STORE_DETAILS.established}
          </p>
          <h2
            id="heritage-heading"
            className="font-display text-[1.75rem] sm:text-4xl lg:text-[2.75rem] font-bold text-ink tracking-tight leading-[1.15]"
          >
            A small shop for everyday needs
          </h2>
        </div>

        <div className="grid lg:grid-cols-[minmax(220px,300px)_minmax(0,1fr)] gap-8 sm:gap-10 lg:gap-14 items-start">
          <div className="relative w-full max-w-[280px] sm:max-w-[300px] mx-auto lg:mx-0">
            <div
              className="absolute -inset-2 sm:-inset-2.5 bg-brand/10 translate-x-1.5 sm:translate-x-2 translate-y-1.5 sm:translate-y-2"
              aria-hidden
            />
            <div className="relative aspect-[3/4] overflow-hidden ring-1 ring-ink/10 bg-stone-200">
              <ImageWithFallback
                src={ASSETS.ownerPhoto}
                alt={`${STORE_DETAILS.owner}, proprietor of Bagbazar Provision Stores`}
                fallbackSrc={FALLBACK_IMAGES.person}
                className="h-full w-full object-cover object-[center_18%]"
                width={ASSET_DIMENSIONS[ASSETS.ownerPhoto]?.[0]}
                height={ASSET_DIMENSIONS[ASSETS.ownerPhoto]?.[1]}
                sizes="(max-width: 1024px) 280px, 300px"
              />
            </div>
          </div>

          <div className="flex flex-col min-w-0">
            <div id="about" className="scroll-mt-24">
              <p className="text-muted text-base sm:text-lg leading-relaxed max-w-xl">
                Run by {STORE_DETAILS.owner}. Rice, flour, oil, snacks, drinks, toiletries — whatever
                you need on Bagbazar road. Call ahead if you want delivery in Pokhara.
              </p>
              <p className="mt-4 text-sm text-muted">
                Proprietor · Established {STORE_DETAILS.established}
              </p>
            </div>

            <div
              id="contact"
              className="scroll-mt-24 mt-8 sm:mt-10 pt-8 sm:pt-10 border-t border-ink/10"
            >
              <div className="flex flex-col gap-5">
                <div>
                  <h3
                    id="contact-heading"
                    className="font-display text-xl sm:text-3xl font-bold text-ink tracking-tight"
                  >
                    Visit or call
                  </h3>
                  <p className="mt-2 text-muted text-sm sm:text-base max-w-sm">
                    Open every day. Walk in, or ring ahead for delivery around Pokhara.
                  </p>
                </div>
                <Button size="lg" href={phoneHref} className="w-full sm:w-auto self-stretch sm:self-start">
                  Call {STORE_DETAILS.phone}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
